// layerOpacity — レイヤー表示濃度 UI の純粋ロジックと control 型
// (docs/_wip/layer-display-opacity-2026-10-12.md)。
//
// 濃さは自分の画面だけ・タブを開いている間だけ (永続しない)。範囲 10〜100%。

export const LAYER_OPACITY_MIN = 0.1;
export const LAYER_OPACITY_MAX = 1;
/** 95% 以上で離したら 100% にスナップ (数字を出さなくても確実に元へ戻せる)。 */
export const LAYER_OPACITY_SNAP_AT = 0.95;
/** キーボード ←→ の刻み。 */
export const LAYER_OPACITY_KEY_STEP = 0.05;

export const clampLayerOpacityValue = (v: number): number => {
  if (Number.isNaN(v)) return LAYER_OPACITY_MAX;
  return Math.min(LAYER_OPACITY_MAX, Math.max(LAYER_OPACITY_MIN, v));
};

/** 離したときの確定値 (95% 以上は 100%)。 */
export const snapLayerOpacity = (v: number): number => {
  const c = clampLayerOpacityValue(v);
  return c >= LAYER_OPACITY_SNAP_AT ? LAYER_OPACITY_MAX : c;
};

/** 現在値から ±5% (1% 単位に丸めて浮動小数の誤差を残さない)。 */
export const stepLayerOpacity = (current: number, direction: 1 | -1): number =>
  clampLayerOpacityValue(Math.round((current + direction * LAYER_OPACITY_KEY_STEP) * 100) / 100);

export const layerOpacityPercent = (v: number): number =>
  Math.round(clampLayerOpacityValue(v) * 100);

/** つまみ操作の窓口 (engine のメソッドを presentation 向けに束ねたもの)。 */
export interface LayerOpacityControl {
  readonly begin: (layerId: number) => void;
  readonly update: (value: number) => void;
  readonly end: (commit: boolean) => void;
  /** プレビューを介さない直接設定 (キーボード用)。 */
  readonly set: (layerId: number, value: number) => void;
}

export const LAYER_OPACITY_NOTICE_TEXT = 'ほかの人にはふつうに見えます。保存もふつうの濃さです';
export const LAYER_OPACITY_NOTICE_STORAGE_KEY = 'oekaki:layer-opacity-notice-seen';
